function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M31.232 5.926L11.695 0 0 38.559l29.305 8.888 8.771-28.919-6.844-12.602zm-6.097 11.308l9.768 2.963-7.31 24.1-24.42-7.407L13.406 3.15 28.06 7.596l-2.924 9.64zm3.173-1.669l2.193-7.23 5.133 9.452-7.326-2.222z",
  fill: "#000"
});

var _ref2 = /*#__PURE__*/React.createElement("circle", {
  cx: 16.471,
  cy: 19.694,
  r: 1.612,
  fill: "#000"
});

var _ref3 = /*#__PURE__*/React.createElement("circle", {
  cx: 26.141,
  cy: 22.918,
  r: 1.612,
  fill: "#000"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M11.209 24.53s4.216 5.875 7.677 6.801c3.462.926 10.048-2.061 10.048-2.061",
  stroke: "#000"
});

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 48,
    fill: "none"
  }, props), _ref, _ref2, _ref3, _ref4);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDEiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0MSA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTMxLjIzMTcgNS45MjU1NkwxMS42OTUyIDBMMy4yNTM1OWUtMDYgMzguNTU4OUwyOS4zMDQ3IDQ3LjQ0NzJMMzguMDc2MSAxOC41MjgxTDMxLjIzMTcgNS45MjU1NlpNMjUuMTM0OSAxNy4yMzQ1TDM0LjkwMzEgMjAuMTk3M0wyNy41OTM2IDQ0LjI5NjZMMy4xNzMwMSAzNi44ODk2TDEzLjQwNjMgMy4xNTA2MkwyOC4wNTg3IDcuNTk0NzlMMjUuMTM0OSAxNy4yMzQ1Wk0yOC4zMDc5IDE1LjU2NTNMMzAuNTAwNyA4LjMzNTQ5TDM1LjYzNDEgMTcuNzg3NEwyOC4zMDc5IDE1LjU2NTNaIiBmaWxsPSJibGFjayIvPgo8Y2lyY2xlIGN4PSIxNi40NzA2IiBjeT0iMTkuNjk0MyIgcj0iMS42MTE3NCIgZmlsbD0iYmxhY2siLz4KPGNpcmNsZSBjeD0iMjYuMTQxIiBjeT0iMjIuOTE3OCIgcj0iMS42MTE3NCIgZmlsbD0iYmxhY2siLz4KPHBhdGggZD0iTTExLjIwODYgMjQuNTI5NUMxMS4yMDg2IDI0LjUyOTUgMTUuNDI1MiAzMC40MDU0IDE4Ljg4NjMgMzEuMzMxQzIyLjM0NzUgMzIuMjU2NiAyOC45MzQxIDI5LjI2OTcgMjguOTM0MSAyOS4yNjk3IiBzdHJva2U9ImJsYWNrIi8+Cjwvc3ZnPgo=";
export { SvgLogo as ReactComponent };